// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"styles_errorContainer__yWLkE","errorIcon":"styles_errorIcon__gDsNA","errorTitle":"styles_errorTitle__189da","errorText":"styles_errorText__h_qOh","errorButton":"styles_errorButton__JyHo1"};
module.exports.__checksum = "e34ddf40fdaf"
